export const depricatedApiUrl = process.env.REACT_APP_DEPRICATED_API_ENDPOINT;
export const apiUrlLogin = process.env.REACT_APP_DEPRICATED_OAUTH_ENDPOINT;
export const coreApiUrl = process.env.REACT_APP_CORE_API_ENDPOINT;
export const newApiUrl = process.env.REACT_APP_NEW_API_ENDPOINT + "/admin";
